<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file BoldWord.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  BoldWord.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: BoldWord 
 Created by keni.
 with: IntelliJ IDEA
 Date: 29/03/2018
 Time: 13:31
------------------------------------------------------------------------------->
<template>
    <span>
        <span v-if="first_word_bold === true">
            <strong>{{words.first}}</strong>
            <span>{{words.last}}</span>
        </span>
        <span v-else>
            <span>{{words.first}}</span>
            <strong>{{words.last}}</strong>
        </span>
    </span>
</template>

<script>
	export default {
		name: "bold-word",
		components: {},
		props: [
			'word', 'first_word_bold'
		],
		created() {
		},
		destroyed() {
		},
		mounted() {
			this.processWord();
		},
		data() {
			return {
				words: {
					first: '',
					last: ''
				}
			}
		},
		methods: {
			processWord() {
				let sentence = this.word.trim(),
					words = sentence.split(' ');

				if (words.length < 2) {
					if (this.first_word_bold === true) {
						this.words.first = sentence;
					}
					else {
						this.words.last = sentence;

					}
					return;
				}

				if (this.first_word_bold === true) {
					this.words.first = words.shift();
					this.words.last = words.join(' ');
				}
				else {

					this.words.last = words.pop();
					this.words.first = words.join(' ');
				}
			}
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/typography/BoldWord.vue